import React from "react";
import { assets } from "../../../Assets/assets";

const CallUs = () => {
  return (
    <div className="w-full px-4 md:px-8 pb-14 sm:pb-16">
      <div className="max-w-7xl mx-auto">

        {/* CARD */}
        <div className="relative bg-[#EED6DB] rounded-2xl w-full overflow-hidden sm:w-[85%] mx-auto min-h-[13rem] md:min-h-[12rem] lg:min-h-[16rem] flex items-center">
          {/* Decorative circles */}
          <div className="absolute -top-6 -right-6 w-28 h-28 rounded-full bg-primaryColor/10" />
          <div className="absolute top-2 -right-2 w-14 h-14 rounded-full bg-primaryColor/10" />
          <div className="absolute -bottom-4 -left-4 w-20 h-20 rounded-full bg-primaryColor/10" />

          {/* IMAGE (OVERFLOW LEFT) */}
          <div className="absolute hidden sm:block left-0 bottom-0">
            <img
              src={assets.callusvector}
              alt="call us"
              className="w-[12rem] md:w-[14rem] lg:w-[300px] rounded-bl-2xl object-contain"
            />
          </div>

          {/* CONTENT */}
          <div className="md:w-full w-fit mx-auto text-center flex justify-end">
            <div className="text-center space-y-1 lg:space-y-4 w-full sm:w-[70%] md:w-[50%] ">

              <p className="text-base md:text-lg lg:text-2xl text-gray-700">
                Contact Us
              </p>

              <a href="tel:+916752455372" className="text-3xl md:text-3xl lg:text-5xl font-semibold text-primaryColor tracking-wide">
                +916752455372
              </a>

              <p className="text-base md:text-lg lg:text-2xl text-gray-700">
                Working Hours 9AM to 6PM (Everyday)
              </p>

            </div>
          </div>

        </div>

      </div>
    </div>
  );
};


export default CallUs;